import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TrialLink from "@components/trial-link";
import React from "react";
var TrialMessage = function(param) {
    var _data = param.data, headers = _data.headers, trialLink = _data.trialLink;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full lg:w-1/2 lg:ml-4 grid grid-cols-1 sm:grid-cols-2 lg:justify-end items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mr-2",
                children: headers
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(TrialLink, _object_spread({}, trialLink))
            })
        ]
    });
};
export default TrialMessage;
